// Task #1660 — Helpers di formato condivisi dai componenti Messenger v2.
// Estratti dal monolite MessengerChat.tsx (1395 LOC) per riuso e leggibilità.

export function formatTime(date: string): string {
  const d = new Date(date);
  const now = new Date();
  const diffMs = now.getTime() - d.getTime();
  const diffMins = Math.floor(diffMs / 60000);
  if (diffMins < 1) return 'ora';
  if (diffMins < 60) return `${diffMins}min fa`;
  const diffHours = Math.floor(diffMins / 60);
  if (diffHours < 24) return d.toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' });
  if (diffHours < 48) return 'ieri';
  return d.toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit' });
}

export function formatMessageTime(date: string): string {
  return new Date(date).toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' });
}

export function getDateSeparator(date: string): string {
  const d = new Date(date);
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  if (d.toDateString() === today.toDateString()) return 'Oggi';
  if (d.toDateString() === yesterday.toDateString()) return 'Ieri';
  return d.toLocaleDateString('it-IT', { weekday: 'long', day: 'numeric', month: 'long' });
}

export function getInitials(firstName?: string | null, lastName?: string | null): string {
  return `${(firstName || '')[0] || ''}${(lastName || '')[0] || ''}`.toUpperCase() || '?';
}

const AVATAR_GRADIENTS = [
  'from-blue-500 to-indigo-600', 'from-emerald-500 to-teal-600', 'from-purple-500 to-violet-600',
  'from-orange-500 to-red-600', 'from-pink-500 to-rose-600', 'from-cyan-500 to-blue-600',
  'from-amber-500 to-orange-600', 'from-indigo-500 to-purple-600',
];

export function getAvatarGradient(name: string): string {
  let hash = 0;
  for (let i = 0; i < (name || '').length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
  return AVATAR_GRADIENTS[Math.abs(hash) % AVATAR_GRADIENTS.length] ?? AVATAR_GRADIENTS[0]!;
}

const SENDER_COLORS = [
  'text-blue-600', 'text-emerald-600', 'text-purple-600', 'text-orange-600',
  'text-pink-600', 'text-teal-600', 'text-indigo-600', 'text-red-500',
];

export function getSenderColor(senderId: string): string {
  let hash = 0;
  for (let i = 0; i < senderId.length; i++) hash = senderId.charCodeAt(i) + ((hash << 5) - hash);
  return SENDER_COLORS[Math.abs(hash) % SENDER_COLORS.length] ?? SENDER_COLORS[0]!;
}

export const EMOJI_LIST = [
  '👍', '❤️', '😂', '😮', '😢', '🔥', '🎉', '👏',
  '💯', '✅', '❌', '⭐', '💪', '🙏', '😍', '🤔',
  '👋', '🎯', '💡', '🚀', '✨', '🙌', '😎', '🤝',
];

// Task #1660 — formato menzione canonico `@[Nome Cognome](uuid)`. Render nel
// MessageItem riconosce questo pattern e applica highlight (mio uuid -> halo
// blu + notifica `chat_mention` server-side).
export const MENTION_RE = /@\[([^\]]+)\]\(([a-f0-9-]+)\)/g;

export function extractMentionedIds(content: string): string[] {
  const ids: string[] = [];
  let m;
  const re = new RegExp(MENTION_RE.source, 'g');
  while ((m = re.exec(content)) !== null) {
    if (m[2]) ids.push(m[2]);
  }
  return ids;
}

// Task #1660 — URL extractor per link preview. Match http(s) liberali, prima
// occorrenza viene mostrata come card sotto il messaggio.
export const URL_RE = /https?:\/\/[^\s<>"'`]+/i;

export function firstUrl(text: string | null | undefined): string | null {
  if (!text) return null;
  const m = text.match(URL_RE);
  return m ? m[0] : null;
}

// Task #1660 — bozza locale per conversazione (no roundtrip server).
const DRAFT_KEY_PREFIX = 'messenger_draft_';
export function getDraft(convId: string): string {
  try { return localStorage.getItem(`${DRAFT_KEY_PREFIX}${convId}`) || ''; } catch { return ''; }
}
export function saveDraft(convId: string, text: string): void {
  try {
    if (text.trim()) localStorage.setItem(`${DRAFT_KEY_PREFIX}${convId}`, text);
    else localStorage.removeItem(`${DRAFT_KEY_PREFIX}${convId}`);
  } catch { /* noop */ }
}
